import { PaginationSkeleton } from '../Pagination';
import { Skeleton, TextSkeleton } from '../Skeleton';

export function DataTableSkeleton(props: { rows?: number }) {
    const { rows = 5 } = props;
    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col">
                <DataTableHeaderRowSkeleton />

                {Array.from({ length: rows }).map((_, index) => (
                    <DataTableRowSkeleton key={index} />
                ))}
            </div>

            <PaginationSkeleton />
        </div>
    );
}

function DataTableHeaderRowSkeleton() {
    return (
        <div className="flex w-full justify-between">
            <TextSkeleton className="py-3">Views</TextSkeleton>

            <TextSkeleton className="py-3">Page</TextSkeleton>
        </div>
    );
}

function DataTableRowSkeleton() {
    return (
        <div className="flex w-full justify-between">
            <div className="flex gap-2 py-3 pr-3">
                <Skeleton className="size-4.5" />
                <TextSkeleton className="text-ui-base">
                    Some placeholder for a page title
                </TextSkeleton>
            </div>

            <TextSkeleton>10</TextSkeleton>
        </div>
    );
}
